export default function (state, action) {
  switch (action.type) {
    case 'CLEAR_REDUX':
      return Object.assign({}, { schedule: state.schedule })
    default:
      return state;
  }
}
